import { authenticatedPatch } from '../../../../../../api/request';

export default async function saveRescheduleAppointment(saveData, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando la actualización de la cita.');
    const url = '/appointment-doctor/cancel-appointment';
    return await authenticatedPatch(url, onFail, saveData);
}
